import { useFormik } from "formik";
import { Avatar } from "primereact/avatar";
import { Sidebar } from "primereact/sidebar";
import React, { useEffect, useState } from "react";
import { Link, Route, Routes, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import fotoNeutro from "../../assets/img/avatar-neutro.png";
import ButtonZegel from "../../components/Buttons/ButtonZegel";
import DialogZegel from "../../components/Dialog/DialogZegel";
import InputPastZegel from "../../components/Inputs/InputPassZegel";
import * as constantes from "../../constants/constantes";
import useAlumno from "../../hooks/useAlumno";
import { PrivateRoutes } from "../../routes/routes";
import { UpdatePassword } from "../../services/UsuarioService";
import BienvenidaCursoPrograma from "../Curso/BienvenidaCursoPrograma";
import BienvenidaCurso from "../Curso/BienvenidaCurso";
import BienvenidaPrograma from "../Curso/BienvenidaPrograma";
import CursoInterno from "../Curso/CursoInterno";
import ProgresoCurso from "../Curso/ProgresoCurso";
import ShareCertificate from "../Curso/ShareCertificate";
import ProgresoPrograma from "../Curso/ProgresoPrograma";
import Dashboard from "../Dashboard/Dashboard";
import EvaluacionExamen from "../Evaluacion/EvaluacionExamen";
import EvaluacionIntro from "../Evaluacion/EvaluacionIntro";
import ResultadosExamen from "../Evaluacion/ResultadosExamen";
import "./styles/Home.scss";
import zegelVirtualPositivo from "../../assets/img/zegelVirtualPositivo.png";

//import * as Iconsax from "iconsax-react";
const Home = () => {
  const navigate = useNavigate();
  const {
    perfil,
    isLogged,
    logout,
    setActivosChecked,
    setFinalizadoChecked,
    setExplorarChecked,
    setIndexActiveCursos,
    setIndexTabPrincipal,
    setIndexTabSecundario
  } = useAlumno();
  const [showChangePass, setShowChangePass] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [contenidoAlert, setContenidoAlert] = useState("");
  useEffect(() => {
    //if (!isLogged) window.location = "#/";
    if (!isLogged) navigate("/Login");
  }, [isLogged]);
  const [visible, setVisible] = useState(false);
  //const Dashboard = lazy(() => import("../Dashboard/Dashboard"));
  const customIcons = (
    <div
      style={{ width: "100%", height: "40px" }}
      className="flex align-items-center"
    >
      <button
        className="p-sidebar-icon p-link mr-2"
        onClick={() => {
          if (showChangePass) {
            setShowChangePass(false);
          } else {
            setVisible(false);
          }
        }}
      >
        <span className="pi pi-arrow-left" />
      </button>
    </div>
  );
  const toggleSidebar = () => {
    setVisible(!visible);
  };
  const cerrarSesion = (e) => {
    e.preventDefault();
    logout();
  };

  const schema = Yup.object().shape({
    passwordOld: Yup.string().required(
      "Contraseña actual es un campo obligatorio"
    ),
    // password: Yup.string().required("Contraseña es un campo obligatorio").min(8, "La contraseña debe tener al menos 8 caracteres"),
    password: Yup.string()
      .required("Contraseña es un campo obligatorio")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/,
        "Tu nueva contraseña debe poseer una extensión de al menos 8 caracteres y contener una mayúscula y un número."
      ),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      password: "",
      passwordRepetido: "",
      passwordOld: "",
    },

    validationSchema: schema,
    onSubmit: (values) => {
      let id = perfil.idUsuario; //
      let password = values.password;
      let passwordRepetido = values.passwordRepetido;
      let passwordOld = values.passwordOld;
      let guid = "11776c46-4df2-487a-97bc-e9c756c95bd7";

      if (passwordRepetido != password) {
        setContenidoAlert("Contraseñas no coinciden.");
        setShowAlert(true);
        formik.setSubmitting(false);
        return;
      }

      let jsonpass = JSON.stringify(
        {
          id,
          guid,
          password,
          passwordOld,
        },
        null,
        2
      );
      let jwt = window.localStorage.getItem("jwt");
      UpdatePassword({ jwt, jsonpass })
        .then((data) => {
          formik.setSubmitting(false);
          setContenidoAlert("Se actualizó contraseña correctamente.");
          setShowAlert(true);
          setTimeout(() => {
            setShowChangePass(false);
            setVisible(false);
            formik.resetForm();
          }, 3000);
        })
        .catch((errors) => {
          setShowChangePass(false);
          setVisible(false);
          setContenidoAlert(errors.message);
          setShowAlert(true);
          formik.setSubmitting(false);
        });
    },
  });
  return (
    <div className="zal-home">
      <div className="zal-home-topbar">
        <ul className="container">
          <li className="topbar-option logoTopbar">
            <Link to={"/" + PrivateRoutes.HOME + "/Dashboard"}>
              <div className="c-icon logoTopbar">
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="156.032"
                  height="26.005"
                  viewBox="0 0 156.032 26.005"
                // href="https://app.zegelvirtual.com/cursos"
                >
                  <path
                    id="Trazado_2645"
                    data-name="Trazado 2645"
                    d="M0,17.45,7.591,8.895H.572V5.876H12.9V8.895L5.287,17.45h8.127v3.018H0Zm18.718-3.3c.107,2.536,1.357,3.7,3.59,3.7A3.287,3.287,0,0,0,25.47,15.95h3.536a6.568,6.568,0,0,1-6.841,4.912c-4.608,0-7.448-3.161-7.448-7.68,0-4.376,3.018-7.716,7.448-7.716,4.965,0,7.377,4.179,7.091,8.68Zm6.537-2.536C24.88,9.573,24,8.5,22.058,8.5a3.185,3.185,0,0,0-3.34,3.108Zm20.272,7.93c0,2.393-.839,6.466-7.573,6.466-2.876,0-6.233-1.357-6.448-4.7h3.983c.375,1.5,1.59,2,3,2,2.233,0,3.251-1.518,3.215-3.608V17.789h-.054a4.953,4.953,0,0,1-4.376,2.268c-4.376,0-6.233-3.34-6.233-7.341,0-3.786,2.179-7.234,6.269-7.234a4.546,4.546,0,0,1,4.358,2.34h.054V5.876h3.822V19.54Zm-3.8-6.555c0-2.375-.822-4.483-3.411-4.483-2.268,0-3.251,1.983-3.251,4.144,0,2.09.786,4.376,3.251,4.376C40.58,17.021,41.723,15.075,41.723,12.985Zm10.2,1.161c.107,2.536,1.357,3.7,3.59,3.7a3.287,3.287,0,0,0,3.161-1.893h3.536a6.568,6.568,0,0,1-6.841,4.912c-4.608,0-7.448-3.161-7.448-7.68,0-4.376,3.018-7.716,7.448-7.716,4.965,0,7.377,4.179,7.091,8.68Zm6.519-2.536c-.375-2.036-1.25-3.108-3.2-3.108A3.185,3.185,0,0,0,51.9,11.61ZM64.8.3h4.019V20.468H64.8ZM73.587,5.7H75.6l4.662,13.056h.054L84.928,5.7H86.8l-5.555,14.86H79.32ZM88.482,0H90.3V2.911H88.482Zm0,5.7H90.3v14.86H88.482Zm5.162,0h1.679V9.18h.054A5.523,5.523,0,0,1,101,5.483v1.84a5.121,5.121,0,0,0-5.537,5.323v7.93H93.644Zm13.217,0h3.018V7.234h-3.018v10.02c0,1.179.179,1.875,1.465,1.965a15.1,15.1,0,0,0,1.554-.089v1.554c-.554,0-1.072.054-1.607.054-2.429,0-3.251-.8-3.233-3.34V7.216h-2.59V5.68h2.59V1.215h1.822V5.7Zm17.557,14.878h-1.679V17.9h-.054A5.532,5.532,0,0,1,117.56,21c-3.751,0-5.215-2.2-5.215-5.644V5.715h1.822V15.4c.089,2.679,1.09,4.09,3.983,4.09,3.108,0,4.465-2.947,4.465-5.966V5.7h1.822V20.576Zm3.108-10.324c.179-3.483,2.626-4.983,6.019-4.983,2.626,0,5.483.8,5.483,4.787V17.95a.96.96,0,0,0,1.072,1.09,1.809,1.809,0,0,0,.572-.107v1.536a4.905,4.905,0,0,1-1.179.107c-1.84,0-2.125-1.036-2.125-2.59h-.054A5.671,5.671,0,0,1,131.9,21c-2.733,0-4.983-1.357-4.983-4.358,0-4.179,4.054-4.322,7.984-4.787,1.5-.179,2.34-.375,2.34-2.018,0-2.447-1.75-3.054-3.894-3.054-2.25,0-3.912,1.036-3.983,3.465h-1.84Zm9.681,2.2h-.054c-.232.429-1.036.572-1.536.661-3.09.554-6.912.518-6.912,3.429a3.1,3.1,0,0,0,3.322,2.947c2.768,0,5.215-1.75,5.18-4.662ZM142.529,0h1.822V20.576h-1.822Zm3.429,22.094h10.073v1H145.959Z"
                    fill="#fff"
                  ></path>
                </svg> */}
                {/* <img
                  src="https://zegelvirtual.nyc3.cdn.digitaloceanspaces.com/assets/business/zegel-virtual/navbar-logo.svg"
                  height={"30px"}
                ></img> */}
                 <img
                    src={zegelVirtualPositivo}
                    height={40} style={{ height: 40 }}
                  ></img> 
              </div>
            </Link>
          </li>
          <li className="topbar-option help>">
            <Link
              style={{ textDecoration: "none" }}
              to={constantes.URL_AYUDA}
              target="_blank"
            >
              <div className="c-icon">
                <span className="text-help">¿Necesitas Ayuda?</span>
              </div>
            </Link>
          </li>
          <li className="topbar-option">
            <Link>
              <div className="c-icon menuTopBar" onClick={toggleSidebar}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="22"
                  viewBox="0 0 24 22"
                >
                  <path
                    id="menu001_-_E002"
                    data-name="menu001 - E002"
                    d="M8-40.5H-16v1.571H8ZM8-30.286H-16v1.571H8ZM8-20.071H-16V-18.5H8Z"
                    transform="translate(16 40.5)"
                    fill="#2b2b2b"
                  ></path>
                </svg>
              </div>
            </Link>
          </li>
        </ul>
      </div>
      <Sidebar
        visible={visible}
        onHide={() => setVisible(false)}
        icons={customIcons}
        position="right"
        className="sidebarHome"
        showCloseIcon={false}
      >
        {!showChangePass ? (
          <>
            <div className="sidebar-avatar flex align-items-center justify-content-center gap-5">
              <Avatar
                image={perfil && (perfil.avatar ? perfil.avatar : fotoNeutro)}
                style={{
                  width: 100,
                  height: 100,
                  minWidth: 100,
                  minHeight: 100,
                }}
                shape="circle"
                //onImageError={()=>alert("error imagen")}
                imageFallback={fotoNeutro}
              />
              <label className="text-xl font-bold">
                {perfil &&
                  perfil.nombres +
                  " " +
                  perfil.primerApellido +
                  " " +
                  perfil.segundoApellido}
              </label>
            </div>
            <div className="sidebar-acciones flex align-items-center justify-content-center">
              <div className="grid gap-4">
                <Link to={"Dashboard"}
                  className="label-action"
                  onClick={() => {
                    setIndexActiveCursos(0);
                    setActivosChecked("curso-activo");
                    setFinalizadoChecked("");
                    setExplorarChecked("");
                    setVisible(false);
                    setIndexTabPrincipal(0)
                  }}
                >
                  Activos
                </Link>
                <Link to={"Dashboard"}
                  className="label-action"
                  onClick={() => {

                    setIndexActiveCursos(1);
                    setActivosChecked("");
                    setFinalizadoChecked("curso-finalizado");
                    setExplorarChecked("");
                    setVisible(false);
                    setIndexTabPrincipal(1)
                  }}
                >
                  Finalizados
                </Link>
                <Link to={"Dashboard"}
                  className="label-action"
                  onClick={() => {
                    setIndexActiveCursos(2);
                    setActivosChecked("");
                    setFinalizadoChecked("");
                    setExplorarChecked("curso-explorado");
                    setVisible(false);
                    setIndexTabPrincipal(2)
                  }}
                >
                  Explorar
                </Link>
              </div>
            </div>
            <div className="sidebar-footer">
              <div className="f-item footer-changePass flex align-items-center justify-content-between">
                <label
                  className="text-sm font-bold"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowChangePass(true)}
                >
                  Cambiar contraseña
                </label>
                <button
                  className="p-link mt-1"
                  onClick={() => setShowChangePass(true)}
                >
                  <span className="pi pi-cog" />
                </button>
              </div>
              <div className="f-item footer-logout flex align-items-center justify-content-between">
                <label
                  className="text-sm font-bold"
                  onClick={cerrarSesion}
                  style={{ cursor: "pointer" }}
                >
                  Cerrar sesión
                </label>
                <button className="p-link mt-1" onClick={cerrarSesion}>
                  <span className="pi pi-sign-out" />
                </button>
              </div>
            </div>
          </>
        ) : (
          <div className=" justify-content-center">
            {/* <span style={{ cursor: "pointer" }} onClick={() => setShowChangePass(false)}>
              <Iconsax.ArrowCircleLeft size={30}></Iconsax.ArrowCircleLeft>
            </span> */}
            <div>
              <button
                className="p-link-button button-img "
                onClick={() => setShowChangePass(false)}
                style={{
                  fontWeight: "bold",
                  color: "#000",
                }}
              >
                <i
                  className="pi pi-arrow-left font-bold"
                  style={{ fontSize: "1rem" }}
                ></i>
              </button>
            </div>
            <form onSubmit={formik.handleSubmit}>
              <div className="lf-credenciales formgrid grid justify-content-center ">
                <div
                  className="field col-12 md:col-12  mt-5"
                  style={{ textAlign: "center" }}
                >
                  <span
                    className="text-title-24"
                    style={{ textAlign: "center" }}
                  >
                    Cambiar contraseña
                  </span>
                </div>
                <div className="field col-12 md:col-12 ">
                  <span className="text-normal-12">
                    Tu nueva contraseña debe poseer una extensión de al menos 8
                    caracteres y contener una mayúscula y un número.
                  </span>
                </div>
                <div className="field col-12 md:col-12 mt-3">
                  <div className="p-float-label">
                    <InputPastZegel
                      id="passwordOld"
                      name="passwordOld"
                      value={formik.values.passwordOld}
                      style={{ width: "100%", height: 50 }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <label
                      htmlFor="passwordOld"
                      style={{ fontSize: 14, color: "#c4c4c4" }}
                    >
                      Contraseña actual
                    </label>
                  </div>
                  <small className="p-error">
                    {formik.touched.passwordOld && formik.errors.passwordOld}
                  </small>
                </div>
                <div className="field col-12 md:col-12 mt-3">
                  <div className="p-float-label">
                    <InputPastZegel
                      id="password"
                      name="password"
                      value={formik.values.password}
                      style={{ width: "100%", height: 50 }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <label
                      htmlFor="pass"
                      style={{ fontSize: 14, color: "#c4c4c4" }}
                    >
                      Nueva contraseña
                    </label>
                  </div>
                  <small className="p-error">
                    {formik.touched.password && formik.errors.password}
                  </small>
                </div>
                <div className="field col-12 md:col-12 mt-3">
                  <div className="p-float-label">
                    <InputPastZegel
                      id="passwordRepetido"
                      name="passwordRepetido"
                      value={formik.values.passwordRepetido}
                      style={{ width: "100%", height: 50 }}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    <label
                      htmlFor="pass"
                      style={{ fontSize: 14, color: "#c4c4c4" }}
                    >
                      Repetir contraseña
                    </label>
                  </div>
                  <small className="p-error">
                    {formik.touched.passwordRepetido &&
                      formik.errors.passwordRepetido}
                  </small>
                </div>

                <div className="field col-12 md:col-12 mt-1">
                  <ButtonZegel
                    label="Actualizar contraseña"
                    color="primary"
                    type="submit"
                    loading={formik.isSubmitting}
                  ></ButtonZegel>
                </div>
              </div>
            </form>
          </div>
        )}
      </Sidebar>
      <div className="layout-main">
        <Routes>
          <Route path={"Dashboard"} element={<Dashboard />}></Route>
          <Route
            path={"ProgresoCurso/:idCurso"}
            element={<ProgresoCurso />}
          ></Route>
   
           <Route
            path={"ShareCertificate/Course/:idCurso"}
            element={<ShareCertificate />}
          ></Route>
          <Route
            path={"ShareCertificate/Program/:idPrograma/:idPersonaPrograma/:idCurso"}
            element={<ShareCertificate />}
          ></Route>
          <Route
            path={"ShareCertificate/InternalCourse/:idPrograma/:idPersonaPrograma/:idCurso"}
            element={<ShareCertificate />}
          ></Route>
           <Route
            path={"BienvenidaCursoPrograma/:idCursoUsuario"}
            element={<BienvenidaCursoPrograma />}
          ></Route>
          <Route
            path={"BienvenidaCurso/:idCursoUsuario"}
            element={<BienvenidaCurso />}
          ></Route>
          <Route
            path={"BienvenidaPrograma/:idCursoUsuario"}
            element={<BienvenidaPrograma />}
          ></Route>
          <Route
            path={"CursoInterno/:idCursoUsuario"}
            element={<CursoInterno />}
          >
            <Route
              path={":idUnidad/:IDLeccion"}
              element={<CursoInterno />}
            ></Route>
            <Route
              path={":idUnidad/:IDLeccion/:idPersonaPrograma"}
              element={<CursoInterno />}
            ></Route>
          </Route>
          <Route
            path={"ProgresoPrograma/:idPrograma/:idPersonaPrograma/:idCurso"}
            element={<ProgresoPrograma />}
          ></Route>
          <Route
            path={"Evaluacion/Introduccion/:IdPersonaCurso/:Intento/:idUnidad"}
            element={<EvaluacionIntro />}
          ></Route>
          <Route
            path={"Evaluacion/Examen/:IdPersonaCurso/:idEvaluacion/:idUnidad"}
            element={<EvaluacionExamen />}
          ></Route>
          <Route
            path={
              "Evaluacion/Resultado/:IdPersonaCurso/:idEvaluacion/:idUnidad"
            }
            element={<ResultadosExamen />}
          ></Route>
        </Routes>
      </div>
      <DialogZegel
        header=""
        visible={showAlert}
        width="30vw"
        onHide={() => setShowAlert(false)}
        footer={<></>}
        contenido={contenidoAlert}
      ></DialogZegel>
    </div>
  );
};

export default Home;
